export NODE = 'NODE'
export RELATION = 'RELATION'
export RELATIONS = 'RELATIONS'
export RELATION_VIEW = 'RELATION_VIEW'
export RELATION_NODE = 'RELATION_NODE'
export ATTRIBUTES = 'ATTRIBUTES'
export ATTRIBUTE_VIEW = 'ATTRIBUTE_VIEW'

export QUERY = 'QUERY'
export QUERIES = 'QUERIES'

export TYPE = 'TYPE'
export TYPES = 'TYPES'
export CREATE_ACTION = 'CREATE_ACTION'
export ACTION = 'ACTION'
export ACTIONS = 'ACTIONS'
export MACROS = 'MACROS'
export MACRO = 'MACRO'
export CREATE_MACRO = 'CREATE_MACRO'
export VIEW = 'VIEW'
export VIEWS = 'VIEWS'
export CREATE_VIEW = 'CREATE_VIEW'

export GROUP = 'GROUP'
export SPREADSHEET = 'SPREADSHEET'

# viewtypes
export VIEWTYPE = {
  ABSTRACT: 'VIEWTYPE_ABSTRACT'
}

export USERMODES = {
  SIMPLE: 1
  ADVANCED: 2
  EXPERT: 3
}
